import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const thane: AreaConfig = {
  name: 'Thane',
  slug: 'thane',
  tagline: 'Doorstep Mobile Repair in Thane',
  description:
    "Thane's growing city gets expert doorstep mobile repair. Minto's certified technicians cover Thane West, Thane East, Naupada, Vasant Vihar, and surrounding areas. Screen, battery, charging port — fixed at your door.",
  localities: [
    'Thane West', 'Thane East', 'Naupada', 'Charai', 'Uthalsar',
    'Vasant Vihar', 'Hiranandani Estate', 'Pokhran Road', 'Manpada',
    'Mumbra', 'Kalwa', 'Diva', 'Kopri', 'Majiwada',
  ],
  zones: [
    {
      name: 'Thane West — Naupada & Vasant Vihar',
      line: 'Central Line',
      station: 'Thane Station (West)',
      localities: ['Thane West', 'Naupada', 'Vasant Vihar', 'Charai', 'Ram Maruti Road', 'Gokhale Road', 'Majiwada'],
      desc: 'Thane West is the prime residential and commercial belt. We cover all housing societies from Naupada to Vasant Vihar.',
    },
    {
      name: 'Hiranandani Estate & Pokhran Road',
      line: 'Central Line',
      station: 'Thane Station',
      localities: ['Hiranandani Estate', 'Pokhran Road No.1', 'Pokhran Road No.2', 'Manpada', 'Brahmand', 'Ghodbunder Road'],
      desc: 'Premium townships of Thane including Hiranandani Estate and Pokhran Road are fully served. Doorstep repair at gated community gates.',
    },
    {
      name: 'Thane East, Kalwa & Mumbra',
      line: 'Central Line',
      station: 'Thane East Station / Kalwa Station / Mumbra Station',
      localities: ['Thane East', 'Uthalsar', 'Kopri', 'Kalwa', 'Mumbra', 'Diva', 'Shil Phata'],
      desc: 'Covering Thane East and the Central line corridor to Mumbra and Kalwa. Same-day doorstep service for all localities.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Thane | Doorstep Phone Repair Service | Minto',
    description:
      'Doorstep mobile repair in Thane West, Thane East, Hiranandani, Naupada, Mumbra & Kalwa. Screen replacement, battery repair. Certified technicians, 90-day warranty. Book now!',
    keywords:
      'mobile repair Thane, phone repair Thane, screen repair Thane, battery replacement Thane, iPhone repair Thane, Samsung repair Thane, Hiranandani phone repair, Naupada mobile repair, Mumbra phone repair, Kalwa mobile repair, doorstep repair Thane, Pokhran Road phone repair',
  },
  faqs: [
    {
      q: 'Do you offer doorstep mobile repair in Thane West?',
      a: 'Yes, we cover all of Thane West including Naupada, Vasant Vihar, Charai, Majiwada, and Gokhale Road.',
    },
    {
      q: 'Do you service Hiranandani Estate in Thane?',
      a: 'Yes, Hiranandani Estate, Pokhran Road, Brahmand, and Ghodbunder Road are covered by our Thane team.',
    },
    {
      q: 'How much does screen repair cost in Thane?',
      a: 'Screen repair starts from ₹999 depending on your phone model. Check exact price on our booking page.',
    },
    {
      q: 'Do you also cover Mumbra and Kalwa near Thane?',
      a: 'Yes, Mumbra, Kalwa, and Diva are covered under our Thane service zone.',
    },
    {
      q: 'What is the warranty on repairs in Thane?',
      a: 'All repairs come with a 90-day warranty covering the same repair if the issue recurs.',
    },
  ],
};

const ThanePage: React.FC = () => <AreaLandingPage area={thane} />;
export default ThanePage;
